module.exports = __webpack_public_path__ + "static/media/background-video.50c38d25.mp4";